<template>
  <div class="container">
    <div class="accountWrap">
      <p class="pb22 fs16 fwb">{{ $t("account.account.account") }}</p>
      <el-form :model="personalForm" :rules="rules" ref="personalForm" label-width="168px" class="msContent">
        <el-form-item :label="$t('account.account.nickname')" prop="nickname">
          <el-input v-model="personalForm.nickname" :placeholder="$t('common.placeholder.enter')" class="wd520 pr70" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item :label="$t('account.account.email')" prop="email">
          <div class="clearfix">
            <p class="fl lh38 mr12">{{ personalForm.email }}</p>
            <p class="fl lh38 blue fs16 crp el-icon-edit" @click="toEmail" v-if="!isCoordinator"></p>
          </div>
        </el-form-item>
        <el-form-item :label="$t('account.account.password')">
          <div class="clearfix">
            <p class="fl hg38 lh44 mr12">********</p>
            <p class="fl lh38 blue fs16 crp el-icon-edit" @click="toPassword" v-if="!isCoordinator"></p>
          </div>
        </el-form-item>
        <el-form-item :label="$t('account.account.phone')" prop="phone">
          <div class="clearfix">
            <p class="fl lh38 mr12">{{ personalForm.phone }}</p>
            <p class="fl lh38 blue fs16 crp el-icon-edit" @click="toPhone"></p>
          </div>
        </el-form-item>
        <el-form-item :label="$t('account.account.receiptLanguage')" prop="emailRecLanguage">
          <el-select v-model="personalForm.emailRecLanguage" class="wd450">
            <el-option :label="$t('account.account.chinese')" value="zh"></el-option>
            <el-option :label="$t('account.account.english')" value="en"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('account.account.residentialAddress')" prop="address">
          <el-input v-model="personalForm.address" :placeholder="$t('common.placeholder.enter')" class="wd520 pr70" maxlength="400" show-word-limit></el-input>
        </el-form-item>

        <el-form-item>
          <el-button class="mr20" @click="() => $router.push('/enroll/creation')">{{ $t("account.account.back") }}</el-button>
          <el-button type="primary" class="pl20 pr20" @click="submitForm('personalForm')">{{ $t("common.button.save") }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { postRequest } from "@/api/common";
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "Account",
  data() {
    return {
      clickSwitch: true, // 防止恶意提交
      personalForm: {
        nickname: null,
        email: null,
        phone: "",
        emailRecLanguage: "zh",
        address: null,
      },
      rules: {
        nickname: [
          {
            required: true,
            message: this.$t("common.placeholder.enter"),
            trigger: "submit",
          },
        ],
        email: [
          {
            required: true,
            message: this.$t("common.placeholder.toEdit"),
            trigger: "submit",
          },
          {
            type: "email",
            message: this.$t("common.regular.email"),
            trigger: "submit",
          },
        ],
        phone: [
          {
            required: true,
            message: this.$t("common.placeholder.toEdit"),
            trigger: "submit",
          },
        ],
        address: [
          {
            required: true,
            message: this.$t("common.placeholder.enter"),
            trigger: "submit",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("user", ["isCoordinator", "userInfo"]),
    ...mapGetters("language", ["getLanguage"]),
  },
  methods: {
    ...mapActions("user", ["fetchUserInfo"]),
    // 修改邮箱
    toEmail() {
      this.$router.push({ path: "/email" });
    },
    // 修改密码
    toPassword() {
      this.$router.push({ path: "/password" });
    },
    // 修改手机号
    toPhone() {
      this.$router.push({ path: "/bind" });
    },
    // 获取个人资料
    getPersonal() {
      this.fetchUserInfo()
        .then(res => {
          this.personalForm = {
            ...this.userInfo,
          };
        })
        .catch(err => {});
    },
    // 保存
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.clickSwitch) {
            this.clickSwitch = false;
            postRequest("/member/updateProfile", {
              nickname: this.personalForm.nickname,
              emailRecLanguage: this.personalForm.emailRecLanguage,
              address: this.personalForm.address,
            })
              .then(res => {
                this.$message.success(this.$t("common.success.save"));
              })
              .catch(err => {
                this.clickSwitch = true;
              });
          }
        } else {
          return false;
        }
      });
    },
  },
  created() {
    // 获取个人资料
    this.getPersonal();
  },
};
</script>

<style lang="scss" scoped>
.accountWrap {
  ::v-deep {
    .el-form-item__label {
      height: 38px;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>
